import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import * as actionsAuth from '../auth/actionsTypes';
import * as actionUserEdu from '../education/actionsTypes';
import gestorDocumentalServices from '../gestorDocumental/gestorDocumental.services';
const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const requesChangesUserContacts = (data, func) => async (dispatch, getState) => {
  
  try {
    dispatch({
      type: actions.REQUEST_CHANGES_LOADER_DATA,
      payload: true
    });
    const { token, username, userOrg } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    
    await client.post(`/api/app/Actualizacion_Contacto/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });

    await client.post(`/api/app/Actualizacion_Datos_Actualizado/`, {userId: username, empresa_id: userOrg}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    
    func(true);

  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.REQUEST_CHANGES_LOADER_DATA,
      payload: false
    });
  }
}

export const requesChangesUserAddress = (data, func) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.REQUEST_CHANGES_LOADER_DATA,
      payload: true
    });
    const { token, username, userOrg } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    
    await client.post(`/api/app/Actualizacion_Domicilio/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });

    await client.post(`/api/app/Actualizacion_Datos_Actualizado/`, {userId: username, empresa_id: userOrg}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    
    func(true);

  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.REQUEST_CHANGES_LOADER_DATA,
      payload: false
    });
  }
}

export const requesChangesUserEducation = (data, func, edit, dataGD, index, editItem, iType, institutoT, tituloT, uploadFile,  setShowModal, setValidFechaDoc) => async (dispatch, getState) => {
  try {
    debugger;
    dispatch({
      type: actionUserEdu.SAVE_LOADER_EDUCATION,
      payload: true
    });
    
    const { token, username, userOrg } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    
    await client.post(`/api/app/Actualizacion_Educacion/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });

    await client.post(`/api/app/Actualizacion_Datos_Actualizado/`, {userId: username, empresa_id: userOrg}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });

    if(uploadFile){
      const { education, educationLength } = getState().education;
      data.instituto = institutoT;
      data.titulo = tituloT;
      dataGD.append("id_registro", parseInt(editItem.id));
      let respGD = null;
      let isnew = false;
      if(edit && editItem.archivos_gestor === null){
        respGD = await gestorDocumentalServices.saveDocument(dataGD);
        isnew = true;
      }else{
        respGD = await gestorDocumentalServices.editDocument(editItem.archivos_gestor, dataGD);
      }
      const respEduc = await client.put(iType === 1 ? `/api/app/Formal_Educacion/${editItem.id}/` : `/api/app/Funcional_Educacion/${editItem.id}/`, {
        ...editItem,
        archivos_gestor: isnew ? respGD.data.resultado.id : respGD.data.id
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }});
      education[index] = respEduc.data;
      dispatch({
        type: actionUserEdu.GET_EDUCATION,
        payload: {
          education: education,
          educationLength: educationLength
        }
      });
    }
    
    func(true);
    setShowModal(false);
    setValidFechaDoc(false);
    
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actionUserEdu.SAVE_LOADER_EDUCATION,
      payload: false
    });
  }
}

export const requesChangesUserCivilState = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.REQUEST_CHANGES_LOADER_DATA,
      payload: true
    });
    const { token, username, userOrg } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    
    await client.post(`/api/app/Actualizacion_Estado_Civil/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });

    await client.post(`/api/app/Actualizacion_Datos_Actualizado/`, {userId: username, empresa_id: userOrg}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });

  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.REQUEST_CHANGES_LOADER_DATA,
      payload: false
    });
  }
}

export const requestNotNeedUpdate = (pr, userId, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.REQUEST_CHANGES_NOT_NEED_UPDATE_LOADER_DATA,
      payload: true
    });
    const { token, username, userOrg } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
     
    await client.post(`/api/app/Actualizacion_Datos_Actualizado/`, {userId: username, empresa_id: userOrg}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    const oAuth = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : null;
    
    if (oAuth){
      localStorage.setItem('auth', JSON.stringify({...oAuth, userUpdated: true}));
      dispatch({
        type: actionsAuth.GET_TOKEN,
        payload: {...oAuth, userUpdated: true}
      });
      pr.history.push(`/detalle-empleado/${userId}/${iType}`);
    }
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.REQUEST_CHANGES_NOT_NEED_UPDATE_LOADER_DATA,
      payload: false
    });
  }
}

export const requestChangesUserDocs = (data, func) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.REQUEST_CHANGES_LOADER_DATA,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    
    await client.post(`/api/app/Configuracion_Actualizacion_Empleado/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    
    func(true);

  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.REQUEST_CHANGES_LOADER_DATA,
      payload: false
    });
  }
}